import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeOrderNameModal, orderNameAdd, clearNextModal, setNextModal, openPaymentModal, addOrder, orderReset } from '../actions/index';
import { Modal } from 'react-bootstrap';

class ModalOrderName extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderName: '',
      orderNameError: '',
    }
  }

  // Handle user changing the name in the modal
  handleOrderNameChange = name => {
    this.setState({ orderName: name });
  }

  // Close the modal and reset it
  handleCloseOrderNameModal = () => {
    this.props.clearNextModal();
    this.setState({ orderName: '', orderNameError: '' });
    this.props.closeOrderNameModal();
  }

  // If the user enters a name in the modal and clicks send
  handleAddOrderName = () => {
    // Only continue if they have entered a name
    if (this.state.orderName !== '') {
      this.props.orderNameAdd(this.state.orderName).then( () => {

        // Add the order to the orders reducer
        this.props.addOrder(this.props.current_order);

        // Reset modal and current order screen
        this.setState({ orderName: '', orderNameError: '' });
        this.props.orderReset();

        this.props.setNextModal(this.props.openPaymentModal);
        this.props.closeOrderNameModal();
      });
    } else {
      this.setState({ orderNameError: 'Please enter a name' });
      this.nameInput.focus();
    }
  }

  // Set focus to the text input (used after modal shows up)
  handleFocus = () => {
    this.nameInput.focus();
  }

  render() {
    return (
      <Modal show={this.props.modals.showOrderNameModal} onHide={this.handleCloseOrderNameModal} onEntered={this.handleFocus}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group">
              <div className="h4 text-primary">Can I get your name for the order?</div>
              <input type="text" ref={(input) => { this.nameInput = input; }} autoFocus className="form-control" onChange={event => this.handleOrderNameChange(event.target.value)} value={this.state.orderName} />
              <div className="text-danger">{this.state.orderNameError}</div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={this.handleCloseOrderNameModal}>CLOSE</button>&nbsp;
          <button type="button" className="btn btn-primary" onClick={this.handleAddOrderName}>SEND</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals, current_order }) {
  return { modals, current_order };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { closeOrderNameModal, orderNameAdd, clearNextModal, setNextModal, openPaymentModal, addOrder, orderReset }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrderName);



// WEBPACK FOOTER //
// ./src/containers/modal_order_name.js